import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { capitalizeFirstLetter } from "../_utils/capitalizeFirstLetter";
import IconComponent from "../components/ui/IconComponent";
import { Colors, Direction } from "../_app/types";
import Text from "./Text";

interface Props {
  gridDirection: Direction;
}

const BadgeDirection = ({ gridDirection }: Props) => {
  const [color, setColor] = useState<string>(capitalizeFirstLetter(gridDirection));

  useEffect(() => {
    capitalizeFirstLetter(gridDirection) === "Central" && setColor("textSecondary");
    capitalizeFirstLetter(gridDirection) === "Long" && setColor(Colors.Success);
    capitalizeFirstLetter(gridDirection) === "Short" && setColor(Colors.Destructive);
  }, [gridDirection]);

  return (
    <Stack direction={"row"} alignItems={"center"} gap="5px">
      <Text variant="regular" color={color}>
        {capitalizeFirstLetter(gridDirection)}
      </Text>
      {capitalizeFirstLetter(gridDirection) === "Long" && (
        <IconComponent iconName={"TradeUp"} hasFill />
      )}
      {capitalizeFirstLetter(gridDirection) === "Short" && (
        <IconComponent iconName={"TradeDown"} hasFill />
      )}
      <Box>
        {capitalizeFirstLetter(gridDirection) === "Central" && (
          <IconComponent iconName={"TradeCenter"} hasStroke hasFill />
        )}
      </Box>
    </Stack>
  );
};

export default BadgeDirection;
